import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SettingsService } from '../foundation/settings/settings.service';

@Pipe({
  name: 'date',
})
export class DateValuePipe extends DatePipe implements PipeTransform {
  constructor(settingsService: SettingsService) {
    super(settingsService.getLocaleId());
  }

  override transform(
    value: Date | string | number,
    format?: string,
    timezone?: string,
    locale?: string
  ): string | null;
  override transform(
    value: null | undefined,
    format?: string,
    timezone?: string,
    locale?: string
  ): null;
  override transform(
    value: Date | string | number | null | undefined,
    format?: string,
    timezone?: string,
    locale?: string
  ): string | null {
    if (format === 'date') {
      format = 'dd. MM. yyyy';
    } else if (format === undefined || format === null) {
      // format = 'dd.MM.yyyy HH:mm';
      format = 'dd.MM.yyyy';
    }

    return super.transform(value, format, timezone, locale);
  }
}
